import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUseCase } from "models/IUseCase";

interface IUseCasesState {
  value: IUseCase[];
  isLoading: boolean;
}

const initialState: IUseCasesState = {
  value: [],
  isLoading: true,
};

export const useCasesSlice = createSlice({
  name: "useCases",
  initialState,
  reducers: {
    setUseCasesLoading: (state, action: PayloadAction<boolean>): void => {
      state.isLoading = action.payload;
    },
    setUseCases: (state, action: PayloadAction<IUseCase[]>): void => {
      state.value = action.payload;
      state.isLoading = false;
    },
    addUseCase: (state, action: PayloadAction<IUseCase>): void => {
      state.value.push(action.payload);
    },
    updateUseCaseInSlice: (state, action: PayloadAction<IUseCase>): void => {
      const index = state.value.findIndex((u) => u.id === action.payload.id);
      if (index !== -1) {
        state.value[index] = action.payload;
      }
    },
    removeUseCase: (state, action: PayloadAction<string>): void => {
      state.value = state.value.filter((u) => u.id !== action.payload);
    },
  },
});

export const {
  setUseCasesLoading,
  setUseCases,
  addUseCase,
  updateUseCaseInSlice,
  removeUseCase,
} = useCasesSlice.actions;

export default useCasesSlice.reducer;
